import connect from 'components/Shared/connect';
import CategoryNavigation from 'views/CategoryPage/categoryNavigation';
import { InfoBlock } from 'components/Shared/InfoBlock';
import { Main } from 'components/Shared/Layout';
import { CategoryPageModel } from 'models/CategoryPageModel';
import { rm } from 'utils';
import Categories, { mapToCategories, Category } from 'components/Categories';
import { CountdownAd } from 'components/CountdownAd';
import { MostPopularProducts } from 'components/MostPopularProducts';
import { ArticlesAndGuides } from 'components/ArticlesAndGuides';
import { EditorialLink } from 'models/EditorialLink';
import { Ad } from 'components/Ad';

const NUMBER_OF_CATEGORY_LINKS = 8;

interface MergedProps extends CategoryPageModel {
  categories: Category[];
  description: string;
  articles: EditorialLink[];
  guides: EditorialLink[];
  header: string;
  longDescription: string;
}

const CategoryPage = (props: MergedProps) => {
  const showAllCategoriesText = rm('navigation_seeallcountcategories');
  const mostPopularProductsTitle = rm('toplist_product_header');
  const productGoto = rm('product_goto');
  const {
    header,
    sliderAds,
    countdownAd,
    categories,
    description,
    usps,
    mostPopularProducts,
    articles,
    guides,
    displayName,
    categoryImage,
    leaderBoardAd,
    longDescription
  } = props;
  return (
    <Main>
      {countdownAd && <CountdownAd {...countdownAd} />}
      <CategoryNavigation
        {...{
          sliderAds,
          header,
          categories,
          description,
          usps,
          displayName,
          categoryImage,
          longDescription
        }}
      />
      {leaderBoardAd && <Ad ad={leaderBoardAd} />}
      <Categories {...{ categories, showAllCategoriesText }} />
      <ArticlesAndGuides {...{ articles, guides }} />
      <MostPopularProducts {...{ mostPopularProducts, mostPopularProductsTitle, productGoto }} />
      <InfoBlock {...{ header, longDescription }} />
    </Main>
  );
};

export default connect<MergedProps>(({ currentPage }) => ({
  displayName: (currentPage as CategoryPageModel).displayName,
  categoryImage: (currentPage as CategoryPageModel).categoryImage,
  header: (currentPage as CategoryPageModel).header,
  longDescription: (currentPage as CategoryPageModel).longDescription,
  sliderAds: (currentPage as CategoryPageModel).sliderAds,
  countdownAd: (currentPage as CategoryPageModel).countdownAd,
  description: (currentPage as CategoryPageModel).shortDescription,
  usps: (currentPage as CategoryPageModel).usps,
  guides: (currentPage as CategoryPageModel).editorialArticles,
  articles: (currentPage as CategoryPageModel).editorialStories,
  leaderBoardAd: (currentPage as CategoryPageModel).leaderBoardAd,
  mostPopularProducts: (currentPage as CategoryPageModel).mostPopularProducts,
  categories: mapToCategories(
    NUMBER_OF_CATEGORY_LINKS,
    (currentPage as CategoryPageModel).sectionCategories
  ),
  breadCrumbs: currentPage.breadCrumbs
}))(CategoryPage);
